import { QueryClient } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { getAuth } from "firebase/auth";
import { ReactNode, useState } from "react";
import { trpc } from "./trpc";

export const SellarTrpcProvider = ({
  children,
  queryClient,
}: {
  children: ReactNode;
  queryClient: QueryClient;
}) => {
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: `${import.meta.env.VITE_API_V2_URL}/trpc`,

          async headers() {
            const user = getAuth().currentUser;
            return {
              "x-sellar-client": "frontend",
              ...(user && {
                authorization: `Bearer ${await user.getIdToken()}`,
              }),
            };
          },
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      {children}
    </trpc.Provider>
  );
};
